import React, { CSSProperties } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import InputBase from '@material-ui/core/InputBase';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles((theme) =>
  createStyles({
    input: {
      position: 'relative',
      width: '100%',
      height: 48,
      padding: '0 12px',
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.grey.A200}`,
      borderRadius: 3,
      boxSizing: 'border-box',
      fontSize: 18,
      fontWeight: 400,
      color: theme.palette.grey.A700,
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderColor: theme.palette.secondary.main,
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0 10px',
        height: 42,
        fontSize: 16,
      },
    },
  }),
);

interface Props {
  onChange?: (props: any) => void;
  onBlur?: () => void;
  name?: string | undefined;
  value: string | number;
  type?: string | undefined;
  label?: string | undefined;
  errorText?: string | undefined;
  disabled?: boolean | undefined;
  style?: CSSProperties | undefined;
  inputRef?: React.Ref<any>;
  defaultValue?: any;
}

const SimpleInput: React.FC<Props> = ({
  onChange,
  onBlur,
  name = '',
  value,
  type = 'text',
  label = '',
  errorText,
  disabled = false,
  style,
  inputRef,
  defaultValue,
}) => {
  const classes = useStyles();
  return (
    <div>
      <InputBase
        classes={classes}
        onChange={(e) => onChange && onChange!(e)}
        onBlur={() => onBlur && onBlur!()}
        name={name}
        value={value}
        type={type}
        placeholder={label}
        fullWidth
        disabled={disabled}
        style={style}
        inputRef={inputRef}
        defaultValue={defaultValue}
      />
      {errorText && <FormHelperText error>{errorText}</FormHelperText>}
    </div>
  );
};

export default SimpleInput;
